import { render } from "./WizardStep1DHW.pug?vue&type=template&id=62780cff&lang=pug"
import script from "./WizardStep1DHW.js?vue&type=script&lang=js"
export * from "./WizardStep1DHW.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__